export const archiveNotificationsBulkActionType = 'archiveNotifications';
